import Icons from "icons/sidebar";
import DollarOutlined from "../../icons/DollarOutlined";

const index = [
  { title: "Заявки", Icon: Icons.SessionsIcon, path: "/dashboard/offer-list", role: ["executor"] },
  { title: "Текущие клиенты", Icon: Icons.UserProfileIcon, path: "/dashboard/contract-list", role: ["executor"] },
  { title: "План занятий", Icon: Icons.CalendarIcon, path: "/dashboard/plan-report", role: ["executor"] },
  { title: "Сводная таблица планов занятий", Icon: Icons.DashboardIcon, path: "/dashboard/pivot-plan-report", role: ["executor"] },

  { title: "Учет занятий", Icon: Icons.UserManagementIcon, path: "/dashboard/work-report", role: ["executor"] },
  { title: "Финансы", Icon: Icons.DollarOutlined, path: "/dashboard/income-report", role: ["executor"] },

  { title: "Расписание", Icon: Icons.DataTableIcon, path: "/dashboard/schedule", role: ["executor"] },

  {
    title: "Запись на встречу",
    Icon: Icons.CalendarIcon,
    role: ["executor"],
    children: [
      { name: "Публичная ссылка", path: "/dashboard/calendly", role: ["executor"] },
      { name: "Типы встреч", path: "/dashboard/calendly/event-types", role: ["executor"] },
      { name: "Расписание приёма", path: "/dashboard/calendly/availability", role: ["executor"] },
      { name: "Бронирования", path: "/dashboard/calendly/bookings", role: ["executor"] },
    ],
  },

  { title: "Задать вопрос", Icon: Icons.ChatIcon, path: "/dashboard/ask-question", role: ["executor", "customer"] },

  { title: "Документы", Icon: Icons.PagesIcon, path: "/dashboard/docs", role: ["executor", "customer"] },
  { title: "Настройки", Icon: Icons.AccountSettingsIcon, path: "/dashboard/account", role: ["executor", "customer"] },
];

export default index;
